import { Injectable } from '@angular/core';
import { StoredCachedService } from '../../../driver/storage/models/stored-cached-service';
import { UUID } from 'angular2-uuid';
import { CachedServiceMapper } from '../../../driver/storage/mappers/cached-service-mapper';
import { DispatchedServiceViewModel } from '../../../driver/models/view-models/dispatched-service.view-model';
import { UserStateService } from 'src/app/user-state/user-state.service';
import { map, Observable } from 'rxjs';
import { CachedServiceRepositoryCacheManager } from '../../cache-manager/cached-service-repository-cache-manager';

/**
 * Operation class that gets a cached service entry by its service's unique identifier.
 */
@Injectable({
	providedIn: 'root'
})
export class GetCachedServiceByIdOperation {

	/** The mapper class to map cached services to and from stored models */
	private readonly cachedServiceMapper = new CachedServiceMapper();

	/**
	 * @constructor
	 * @param cachedServiceRepositoryCacheManager Cache manager used to interact with the CachedServiceRepository
	 * @param userStateService Service to access the current user's state.
	 */
	constructor(
		private readonly cachedServiceRepositoryCacheManager: CachedServiceRepositoryCacheManager,
		private readonly userStateService: UserStateService
	) { }

	/**
	 * Executes the operation to retrieve a specific cached service entry by its unique identifier.
	 * @param id The unique identifier of the service to retrieve.
	 * @returns Observable emitting the matching DispatchedServiceViewModel if found, or null otherwise.
	 */
	public Execute$(id: UUID): Observable<DispatchedServiceViewModel | null> {
		return this.cachedServiceRepositoryCacheManager.GetByIndex$({
			Id: id,
			UserName: this.userStateService.State.Username!,
			CrownId: this.userStateService.State.CrownIdentifier!
		}).pipe(
			map((storedCachedService: StoredCachedService[] | null) => {
				if (storedCachedService && storedCachedService.length > 0) {
					const cachedService: StoredCachedService = storedCachedService[0];
					return this.cachedServiceMapper.FromStored(cachedService);
				}
				return null;
			})
		);
	}
}
